import { toObject } from "../../core/utils";
import constants from "../../core/constants";

class DeductionPlanPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    const format = (data) => {
      data.delay_deduction /= constants.currencyBy;
      data.ride_late_deduction.map((obj) => {
        if (obj.threshold) {
          obj.threshold /= constants.fromMinToMilli;
        }
        if (obj.amount) {
          switch (obj.type) {
            case "percentage":
              obj.amount *= constants.percentage;
              break;
            case "fixed":
              obj.amount /= constants.currencyBy;
              break;
            default:
              break;
          }
        }
        obj.isDisabled = true;
        return obj;
      });
      return data;
    };
    return toObject(format(data));
  }
}

export default DeductionPlanPageTransform;



// WEBPACK FOOTER //
// ./src/pages/deductionPlan/deductionPlan.transforms.js